import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { database, ref, get } from "../../../firebase";

const CallClose = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [firebaseToken, setFirebaseToken] = useState("");

  const [callCloseData, setCallCloseData] = useState({
    UserId: localStorage.getItem("UserID") || "",
    OutletId: "",
    Outlet_name: "",
    Call_Id: "",
    SupportEnggCallId: id,
    AdminToSupportEngg_id: "",
    SupportEnggName: "",
    CallCloseStatus: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_API}/SupportEngg/${id}`
        );

        if (response.data.success && response.data.data) {
          const {
            OutletId,
            Call_Status,
            UserId,
            Call_Id,
            AdminToSupportEngg_id,
            SupportEnggName,
            SupportEnggMobileNo,
          } = response.data.data;

          setCallCloseData((prevData) => ({
            ...prevData,
            OutletId: OutletId?._id || "",
            Outlet_name: OutletId?.Outlet_name || "",
            SupportEnggName: UserId?.User_Name || "",
            AdminToSupportEngg_id: AdminToSupportEngg_id?._id || "",
            Call_Id: Call_Id?._id || "",
            CallCloseStatus: Call_Status || "",
          }));

          // Fetch Firebase User Token based on the API's UserId._id
          await fetchFirebaseUsers(UserId._id);
        } else {
          console.error("Data not found:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [id]);

  const handleSubmitSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_API}/CallCloseStatus`,
        callCloseData
      );
      console.log("POST request successful:", response.data);
      setCallCloseData({
        ...callCloseData,
        SupportEnggName: "",
        CallCloseStatus: "",
        AdminToSupportEngg_id: "",
      });
      navigate("/ClinetCallCloseStatus");
      SendNotificationProcess();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setCallCloseData({
      ...callCloseData,
      [name]: value,
    });
  };

  const fetchFirebaseUsers = async (userId) => {
    try {
      const usersRef = ref(database, 'users');
      const snapshot = await get(usersRef);

      if (snapshot.exists()) {
        const users = snapshot.val();
        const selectedUser = Object.values(users).find(user => user.UserId === userId);
        if (selectedUser) {
          console.log("Selected Firebase User:", selectedUser); 
          setFirebaseToken(selectedUser.firebaseToken);
        } else {
          console.log("Selected user not found in Firebase.");
        }
      } else {
        console.log("No users found.");
      }
    } catch (error) {
      console.error("Error fetching users from Firebase:", error);
    }
  };

  const SendNotificationProcess = async () => {
    try {
      if (!firebaseToken) {
        console.error("Firebase token is not set");
        return;
      }

      if (!callCloseData.OutletId || !callCloseData.SupportEnggName) {
        console.error("Selected call data is missing");
        return;
      }

      const imageURL = "/static/media/NavbarLogo.7aff387d8291bb227a01.png";

      const response = await axios.post(`${process.env.REACT_APP_SERVER_API}/sendnotification`, {
        token: firebaseToken,
        title: `Restaurant: ${callCloseData.Outlet_name} Call Closed`,
        body: "Thank You",
        image: imageURL,
      });

      console.log("Notification sent successfully:", response.data);
    } catch (error) {
      console.error("Failed to send notification:", error);
    }
  };

  return (
    <div className="container mt-5">
      <div className="row d-flex justify-content-center">
        <div className="col-md-4 shadow-lg p-3 mb-5 bg-body rounded">
          <form onSubmit={handleSubmitSubmit}>
            <div className="form-floating mb-3">
              <select
                className="form-select"
                name="CallCloseStatus"
                value={callCloseData.CallCloseStatus}
                onChange={handleOnChange}
                aria-label="Select Call Status"
                required
              >
                <option value="">Select Status</option>
                <option value="Call Close">Call Close</option>
              </select>
              <label htmlFor="CallCloseStatus">Select Call Status</label>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CallClose;
